export default {"src":"/uk/_next/static/media/darkGreyInfoIcon.7e2792d1.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};